import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchLostDamagedList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/lostDamaged/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            
            if(res.data.try_again) {
                dispatch('fetchLostDamagedList', payload)
            } else {
                commit('setLostDamagedList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchLostDamagedRequest = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/lostDamaged/fetchLostDamagedRequest.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchLostDamagedRequest', payload)
            } else {
                commit('setLostDamagedRequestList', res.data.response)         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchLostDamagedData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/lostDamaged/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setLostDamagedData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }
            
        } else {
            commit('resetLostDamagedData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitLostDamagedData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/lostDamaged/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchLostDamagedData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteLostDamagedData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/lostDamaged/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchLostDamagedList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/lostDamaged/actions.js